export default __webpack_public_path__ + "static/media/trade_hk_06.73458eb0.png";